__turbopack_context__.v({
  "hoverContainer": "Header9-module__mPuYua__hoverContainer",
  "logo": "Header9-module__mPuYua__logo",
  "memberMenu": "Header9-module__mPuYua__memberMenu",
  "orderMenuContent": "Header9-module__mPuYua__orderMenuContent",
  "orderMenuLink": "Header9-module__mPuYua__orderMenuLink",
  "orderMessageBadge": "Header9-module__mPuYua__orderMessageBadge",
  "orderMessageMenuBadge": "Header9-module__mPuYua__orderMessageMenuBadge",
});
